<template>
  <div>
    <v-row>
      <v-col cols="12">
        <SGPFormSelectComponent
          :name="'ctrl_processo_id'"
          :listaDeOptions="listaDeProcessosFiltrados"
          v-model="formulario.ctrl_processo_id"
          :optionLabel="'processo'"
          placeholder="Selecione um Processo"
          data-vv-as="Processo"
          v-validate="'required'"
          :error="validationErrors.first('ctrl_processo_id')"
          @change="listarTarefasPorProcesso"
        />
      </v-col>
    </v-row>
    <v-row v-if="formulario.ctrl_processo_id">
      <v-col cols="12">
        <SGPFormSelectComponent
          :name="'ctrl_tarefa_id'"
          :listaDeOptions="listaDeTarefasFiltradas"
          v-model="formulario.ctrl_tarefa_id"
          :optionLabel="'tarefa'"
          placeholder="Selecione uma Tarefa"
          data-vv-as="Tarefa"
          v-validate="'required'"
          :error="validationErrors.first('ctrl_tarefa_id')"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="text-right">
        <button
          class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize mr-2"
          type="button"
          @click="vincular"
          :disabled="!formulario.ctrl_tarefa_id || loading"
        >
          Vincular
        </button>
        <button
          class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
          type="button"
          @click="fecharModal"
          :disabled="loading"
        >
          Cancelar
        </button>
      </v-col>
    </v-row>

    <SGPLoadingComponent v-if="loading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'VincularTarefaModalComponent',

  props: {
    workflowRecuperacao: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      formulario: {
        ctrl_processo_id: '',
        ctrl_tarefa_id: ''
      },
      loading: false
    };
  },

  created() {
    this.listarProcessos();
  },

  computed: {
    ...mapGetters('ctrlProcessos', ['listaDeProcessos']),
    ...mapGetters('ctrlTarefas', ['listaDeTarefas']),

    workflowId() {
      // Tenta pegar o ctrl_workflow_id de diferentes estruturas possíveis
      return this.workflowRecuperacao.pco_workflow?.ctrl_workflow?.id ||
             this.workflowRecuperacao.pco_workflow?.ctrl_workflow_id ||
             this.workflowRecuperacao.ctrl_workflow_id;
    },

    listaDeProcessosFiltrados() {
      if (!this.workflowId) {
        console.warn('Workflow ID não encontrado', this.workflowRecuperacao);
        return [];
      }

      return this.listaDeProcessos.filter(
        processo => processo.ctrl_workflow_id === this.workflowId
      );
    },

    listaDeTarefasFiltradas() {
      if (!this.formulario.ctrl_processo_id) {
        return [];
      }

      return this.listaDeTarefas.filter(
        tarefa => tarefa.ctrl_processo_id === this.formulario.ctrl_processo_id
      );
    }
  },

  methods: {
    ...mapActions('ctrlProcessos', ['listarProcessos']),
    ...mapActions('ctrlTarefas', ['listarTarefas']),
    ...mapActions('ctrlWorkflowRecuperacao', ['vincularTarefaAoTicket']),

    async listarTarefasPorProcesso() {
      this.formulario.ctrl_tarefa_id = '';
      await this.listarTarefas();
    },

    async vincular() {
      const valido = await this.$validator.validateAll();
      if (!valido) return;

      this.loading = true;

      const payload = {
        id: this.workflowRecuperacao.id,
        ctrl_tarefa_id: this.formulario.ctrl_tarefa_id
      };

      const resp = await this.vincularTarefaAoTicket(payload);
      
      this.loading = false;

      if (resp) {
        this.fecharModal();
      }
    },

    fecharModal() {
      this.$emit('sgpModalFechar');
    }
  }
};
</script>
